<template>
  <div class="volunteerRecruitList">
    <BasePage mode="list">
      <div slot="toolBar">
        <el-row>
          <el-col :span="12">
            <el-button
              size="small"
              icon="el-icon-plus"
              @click="add"
              v-access:add
              type="danger"
              >新增</el-button
            >
          </el-col>
          <el-col :span="12">
            <div class="search-box">
              <el-input
                class="toolBar-search"
                v-model="request.searchKey"
                placeholder="活动类型"
              />
              <el-button
                size="small"
                icon="el-icon-search"
                type="danger"
                @click="loadData(1)"
                >查询</el-button
              >
            </div>
          </el-col>
        </el-row>
      </div>
      <el-table
        :data="list"
        v-loading="loading"
        style="width: 100%"
        border
        :max-height="tableMaxHeight()"
      >
        <el-table-column
          prop="Id"
          label="活动编号"
          width="160"
          :show-overflow-tooltip="true"
          fixed
        />
        <el-table-column
          prop="Title"
          label="活动标题"
          width="350"
          :show-overflow-tooltip="true"
        />
        <el-table-column prop="ActivityType" label="活动类型" width="120" />
        <el-table-column label="活动时间" width="270">
          <template slot-scope="scope">
            {{ (scope.row.ActivityStartTime * 1000) | formatDate }}
            至
            {{ (scope.row.ActivityEndTime * 1000) | formatDate }}
          </template>
        </el-table-column>
        <el-table-column prop="ApplyEndTime" label="报名截止时间" width="140">
          <template slot-scope="scope">
            {{ (scope.row.ApplyEndTime * 1000) | formatDate }}
          </template>
        </el-table-column>
        <el-table-column prop="State" label="活动状态" width="100">
          <template slot-scope="scope">
            {{ showState(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column prop="CreateTime" label="发布时间" width="135">
          <template slot-scope="scope">
            {{ (scope.row.CreateTime * 1000) | formatDate }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200" fixed="right">
          <template slot-scope="scope">
            <el-button
              v-access:read
              type="text"
              size="mini"
              @click="query(scope.row)"
              v-if="scope.row.State !== 4"
              >详情
            </el-button>
            <el-button
              v-access:modify
              type="text"
              size="mini"
              @click="updateState(scope.row)"
              v-if="scope.row.State === 4"
              >发布
            </el-button>
            <el-button
              v-access:modify
              type="text"
              size="mini"
              @click="rollback(scope.row)"
              v-if="
                scope.row.State === 2 &&
                scope.row.ActivityStartTime * 1000 > Date.now()
              "
              >撤销
            </el-button>
            <el-button
              v-access:modify
              type="text"
              size="mini"
              @click="showQRCode(scope.row)"
              v-if="scope.row.State === 2"
              >签到/签退二维码
            </el-button>
            <el-button
              v-access:modify
              type="text"
              size="mini"
              @click="edit(scope.row)"
              v-if="scope.row.State === 4"
              >编辑
            </el-button>
            <el-button
              v-access:modify
              type="text"
              size="mini"
              @click="deleted(scope.row)"
              v-if="scope.row.State === 4"
              >删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-wapper">
        <OfPagination
          :total="total"
          :pageSize="request.pageSize"
          :currentPage="request.pageIndex"
          @onSizeChange="handleSizeChange"
          @onCurrentChange="handleCurrentChange"
        ></OfPagination>
      </div>
    </BasePage>
    <el-dialog :title="title" :visible.sync="dialogVisible" width="60%">
      <div class="editContent">
        <el-form
          :model="form"
          ref="form"
          :rules="rules"
          label-width="120px"
          label-position="right"
        >
          <h4>活动联系人基本信息</h4>
          <el-row>
            <el-col :span="12">
              <el-form-item label="活动联系人：" prop="Leader">
                <el-input
                  v-model="form.Leader"
                  placeholder="请输入活动联系人"
                  style="width: 95%"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="手机号：" prop="LeaderMobile">
                <el-input
                  v-model="form.LeaderMobile"
                  placeholder="请输入手机号"
                  style="width: 95%"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <h4>活动基本信息</h4>
          <el-form-item label="活动类型：" prop="ActivityType">
            <el-select v-model="form.ActivityType" placeholder="请选择">
              <el-option
                v-for="item in activityTypeList"
                :key="item.Id"
                :label="item.ActivityType"
                :value="item.ActivityType"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="活动标题：" prop="Title">
            <el-input
              v-model="form.Title"
              placeholder="请输入活动标题"
              style="width: 90%"
              maxlength="100"
            />
          </el-form-item>
          <el-form-item label="活动日期：" prop="ApplyStartTime">
            <el-date-picker
              v-model="form.ActivityStartTime"
              type="datetime"
              value-format="timestamp"
              :picker-options="pickerOptions0"
              placeholder="开始日期"
            >
            </el-date-picker>
            至
            <el-date-picker
              v-model="form.ActivityEndTime"
              type="datetime"
              value-format="timestamp"
              :picker-options="pickerOptions1"
              placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="报名截止日期：" prop="ActivityEndTime">
            <!-- <el-date-picker
                                v-model="form.ApplyStartTime"
                                type="datetime"
                                :picker-options="ActivitypickerOptions0"
                                placeholder="开始日期">
                        </el-date-picker>
                        至 -->
            <el-date-picker
              v-model="form.ApplyEndTime"
              type="datetime"
              value-format="timestamp"
              :picker-options="ActivitypickerOptions1"
              placeholder="报名截止日期"
            >
            </el-date-picker>
          </el-form-item>

          <el-form-item label="服务地址：" prop="Address">
            <v-region :town="true" v-model="addre" @values="regionChange" />
            <el-input
              v-model="form.Address"
              placeholder="请输入服务详细地址"
              style="width: 90%"
              maxlength="200"
            />
          </el-form-item>
          <el-form-item label="服务地点坐标：" prop="Coordinates">
            <el-input
              v-model="form.Coordinates"
              placeholder="请输入服务地点坐标"
              style="width: 30%"
              maxlength="64"
            />
            <a
              href="http://api.map.baidu.com/lbsapi/getpoint/"
              target="_blank"
              style="margin-left: 5px; color: blue; border-bottom: 1px solid"
              >获取坐标</a
            >
          </el-form-item>
          <el-form-item label="需求人数：" prop="RecruitNumber">
            <el-input
              v-model="form.RecruitNumber"
              oninput="value=value.replace(/[^0-9.]/g,'')"
              placeholder="请输入需求人数"
              style="width: 30%"
            />
          </el-form-item>
          <el-form-item label="封面图：" prop="RecruitNumber">
            <el-upload
              class="upload-demo"
              drag
              :limit="1"
              accept=".jpg, .png"
              action="/api/File/FileUpload"
              :on-success="onSuccess"
              :on-exceed="onExceed"
              :file-list="fileList"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                将文件拖到此处，或<em>点击上传</em>
              </div>
              <div class="el-upload__tip" slot="tip">
                只能上传jpg/png文件，且不超过500kb
              </div>
            </el-upload>
          </el-form-item>
          <el-form-item label="报名限制：" prop="SignUpLimit">
            <el-input
              v-model="form.SignUpLimit"
              placeholder="请输入报名限制"
              maxlength="100"
              show-word-limit
              style="width: 90%"
            />
          </el-form-item>
          <el-form-item label="报名要求：" prop="Requirements">
            <el-input
              v-model="form.Requirements"
              placeholder="请输入报名要求"
              :rows="4"
              maxlength="500"
              show-word-limit
              style="width: 90%"
            />
          </el-form-item>
          <el-form-item label="活动简介：" prop="Describe">
            <el-input
              v-model="form.Describe"
              type="textarea"
              :rows="4"
              maxlength="1000"
              show-word-limit
              placeholder="请输入活动简介"
              style="width: 90%"
            />
          </el-form-item>
          <el-form-item label="活动内容：" prop="Content">
            <el-input
              v-model="form.Content"
              type="textarea"
              :rows="4"
              maxlength="1000"
              show-word-limit
              placeholder="请输入活动内容"
              style="width: 90%"
            />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="onSubmit">确 定</el-button>
      </span>
    </el-dialog>
    <print :qrCodeForm="qrCodeForm" :tips="tips" v-if="showPrint" />
    <el-dialog
      title="志愿者服务二维码"
      :visible.sync="qrCodeDialog"
      width="40%"
      class="qrCodeDialog"
    >
      <!-- <el-form :model="qrCodeForm" ref="form" label-width="120px" label-position="right" v-if="isCreateQRCode">
                <el-form-item label="签到/签退时间：">
                    <el-date-picker
                            class="datePicker"
                            v-model="signTime"
                            type="datetimerange"
                            value-format="timestamp"
                            format="yyyy-MM-dd HH:mm"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>
            </el-form> -->
      <print
        ref="myPrint"
        :qrCodeForm="qrCodeForm"
        :tips="tips"
        :qrCodeUrl="qrCodeUrl"
        v-if="qrCodeDialog"
      />
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
        <!-- <el-button type="primary" @click="createQRCode" v-if="isCreateQRCode">下一步</el-button> -->
        <el-button type="primary" @click="printQRCode">打印</el-button>
      </span>
    </el-dialog>
    <el-dialog :title="title" :visible.sync="showQuery" width="60%">
      <div class="query-content">
        <div class="query-row">
          <div class="query-label">活动联系人：</div>
          <div class="query-value">{{ queryForm.Leader }}</div>
        </div>
        <div class="query-row">
          <div class="query-label">手机号：</div>
          <div class="query-value">{{ queryForm.LeaderMobile }}</div>
        </div>
        <div class="query-row">
          <div class="query-label">活动类型：</div>
          <div class="query-value">{{ queryForm.ActivityType }}</div>
        </div>
        <div class="query-row">
          <div class="query-label">活动标题：</div>
          <div class="query-value">{{ queryForm.Title }}</div>
        </div>
        <div class="query-row">
          <div class="query-label">活动日期：</div>
          <div class="query-value">
            {{ (queryForm.ActivityStartTime * 1000) | formatDate }} -
            {{ (queryForm.ActivityEndTime * 1000) | formatDate }}
          </div>
        </div>
        <div class="query-row">
          <div class="query-label">报名截止日期：</div>
          <div class="query-value">
            {{ (queryForm.ApplyEndTime * 1000) | formatDate }}
          </div>
        </div>
        <div class="query-row">
          <div class="query-label">服务地址：</div>
          <div class="query-value">
            {{ queryForm.CityName }} + {{ queryForm.Address }}
          </div>
        </div>
        <div class="query-row">
          <div class="query-label">服务地点坐标：</div>
          <div class="query-value">{{ queryForm.Coordinates }}</div>
        </div>
        <div class="query-row">
          <div class="query-label">活动联系人：</div>
          <div class="query-value">{{ queryForm.Leader }}</div>
        </div>
        <div class="query-row">
          <div class="query-label">需求人数：</div>
          <div class="query-value">{{ queryForm.RecruitNumber }}</div>
        </div>
        <div class="query-row">
          <div class="query-label">封面图：</div>
          <div class="query-value">
            <el-row>
              <el-col :span="20">{{ cover.name || "-" }}</el-col>
              <el-col :span="4">
                <el-button class="btnCover" type="text" @click="showImageViewer"
                  >查看</el-button
                >
                <el-button class="btnCover" type="text" @click="download"
                  >下载</el-button
                >
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="query-row">
          <div class="query-label">报名限制：</div>
          <div class="query-value">{{ queryForm.SignUpLimit }}</div>
        </div>
        <div class="query-row">
          <div class="query-label">报名要求：</div>
          <div class="query-value">{{ queryForm.Requirements }}</div>
        </div>
        <div class="query-row">
          <div class="query-label">活动简介：</div>
          <div class="query-value">{{ queryForm.Describe }}</div>
        </div>
        <div class="query-row">
          <div class="query-label">活动内容：</div>
          <div class="query-value">{{ queryForm.Content }}</div>
        </div>
      </div>
    </el-dialog>
    <imageViewer
      v-if="isShowImageViewe"
      :imageViewerUrl="imageViewerUrl"
      @closeImageViewer="closeImageViewer"
    />
  </div>
</template>
<script>
import BasePage from "@/components/base/of_page/of_page";
import OfPagination from "@/components/controls/of_pagination/of_pagination";
import api from "@/modules/zjrc/api";
import { formatData } from "@/utils";
import store from "@/store";
import print from "@/modules/zjrc/pages/volunteer/recruit/print.vue";
import { saveAs } from "file-saver";
import imageViewer from "@/components/controls/of_imageViewer";

export default {
  name: "volunteerRecruitList",
  data() {
    //手机号码验证规则
    var checkMobileNo = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入电话号码"));
      }
      if (!/^1[0-9]{10}$/.test(value)) {
        return callback(new Error("无效手机号码"));
      }
      callback();
    };
    var validatorTime = (rule, value, callback) => {
      let vm = this;
      if (
        vm.form.ActivityStartTime === undefined ||
        vm.form.ActivityEndTime === undefined
      ) {
        return callback(new Error("活动开始日期或结束日期不能为空"));
      }
      callback();
    };
    return {
      headers: {
        "OF-Authorization": store.getters.GetUserToken,
      },
      fileList: [],
      request: {
        pageIndex: 1,
        pageSize: 15,
        searchKey: "",
      },
      list: [],
      total: 0,
      loading: false,
      title: "",
      dialogVisible: false,
      form: {
        ApplyStartTime: "",
        ApplyEndTime: "",
        ActivityStartTime: "",
        ActivityEndTime: "",
      },
      rules: {
        Leader: {
          required: true,
          message: "请输入活动联系人",
          trigger: "blur",
        },
        LeaderMobile: {
          required: true,
          validator: checkMobileNo,
          trigger: "blur",
        },
        ActivityType: {
          required: true,
          message: "请选择活动类型",
          trigger: "blur",
        },
        Title: {
          required: true,
          message: "请输入活动标题",
          trigger: "blur",
        },
        Address: {
          required: true,
          message: "请输入服务地址",
          trigger: "blur",
        },
        Coordinates: {
          required: true,
          message: "请输入服务地点坐标",
          trigger: "blur",
        },
        RecruitNumber: {
          required: true,
          message: "请输入需求人数",
          trigger: "blur",
        },
        SignUpLimit: {
          required: true,
          message: "请输入报名限制",
          trigger: "blur",
        },
        Requirements: {
          required: true,
          message: "请输入报名要求",
          trigger: "blur",
        },
        Describe: {
          required: true,
          message: "请输入活动简介",
          trigger: "blur",
        },
        Content: {
          required: true,
          message: "请输入活动内容",
          trigger: "blur",
        },
        ApplyStartTime: {
          required: true,
          validator: validatorTime,
          trigger: "blur",
        },
      },
      activityTypeList: [],
      //activityTime: [],
      activityTimeStart: "",
      activityTimeEnd: "",

      applyTime: [],
      addre: {
        province: "",
        city: "",
        area: "",
        town: "",
      }, //地址
      qrCodeDialog: false,
      qrCodeForm: {},
      signTime: [],
      isCreateQRCode: true,
      qrCodeUrl: "",
      tips: {},
      showPrint: false,
      pickerOptions0: {
        disabledDate: (time) => {
          if (this.form.ApplyEndTime && this.form.ApplyEndTime != "") {
            // let currentTime = this.form.ApplyEndTime;
            //let threeMonths = currentTime.setMonth(currentTime.getMonth() - 1);
            //currentTime.setMonth(currentTime.getMonth() + 1)
            return (
              time.getTime() >= this.form.ApplyEndTime - 24 * 60 * 60 * 1000
            ); //|| time.getTime() < threeMonths;
          } else {
            return time.getTime() <= Date.now() - 24 * 60 * 60 * 1000;
          }
        },
      },
      pickerOptions1: {
        disabledDate: (time) => {
          if (this.form.ApplyStartTime && this.form.ApplyStartTime != "") {
            // let currentTime = this.form.ApplyStartTime;
            //let threeMonths = currentTime.setMonth(currentTime.getMonth() + 1);
            //currentTime.setMonth(currentTime.getMonth() - 1)
            return (
              time.getTime() <= this.form.ApplyStartTime - 24 * 60 * 60 * 1000
            ); //|| time.getTime() > threeMonths;
          } else {
            return time.getTime() <= Date.now() - 24 * 60 * 60 * 1000;
          }
        },
      },
      ActivitypickerOptions0: {
        disabledDate: (time) => {
          if (this.form.ActivityEndTime && this.form.ActivityEndTime != "") {
            // let currentTime = this.form.ActivityEndTime;
            //let threeMonths = currentTime.setMonth(currentTime.getMonth() - 1);
            //currentTime.setMonth(currentTime.getMonth() + 1)
            return (
              time.getTime() >= this.form.ActivityEndTime - 24 * 60 * 60 * 1000
            ); //|| time.getTime() < threeMonths;
          } else {
            return time.getTime() <= Date.now() - 24 * 60 * 60 * 1000;
          }
        },
      },
      ActivitypickerOptions1: {
        disabledDate: (time) => {
          if (
            this.form.ActivityStartTime &&
            this.form.ActivityStartTime != ""
          ) {
            // let currentTime = this.form.ActivityStartTime;
            //let threeMonths = currentTime.setMonth(currentTime.getMonth() + 1);
            //currentTime.setMonth(currentTime.getMonth() - 1)
            return (
              time.getTime() <= this.form.ApplyStartTime - 24 * 60 * 60 * 1000
            ); //|| time.getTime() > threeMonths;
          } else {
            return time.getTime() <= Date.now() - 24 * 60 * 60 * 1000;
          }
        },
      },
      showQuery: false,
      queryForm: {},
      isShowImageViewe: false,
      imageViewerUrl: "",
      cover: {},
    };
  },
  components: {
    BasePage,
    OfPagination,
    print,
    imageViewer,
  },
  mounted() {
    const vm = this;
    vm.loadData(1);
  },
  methods: {
    closeDialog() {
      let vm = this;
      vm.qrCodeDialog = false;
      vm.qrCodeUrl = null;
    },
    closeImageViewer() {
      const vm = this;
      vm.isShowImageViewe = false;
    },
    download() {
      const vm = this;
      saveAs(vm.cover.url, vm.cover.name);
    },
    showImageViewer() {
      const vm = this;
      vm.imageViewerUrl = vm.cover.url;
      vm.isShowImageViewe = true;
    },
    query(row) {
      const vm = this;
      vm.queryForm = row;
      if (row.Cover && row.Cover !== null && row.Cover !== "") {
        vm.cover = JSON.parse(row.Cover);
      }
      vm.showQuery = true;
    },
    printQRCode() {
      const vm = this;
      vm.$refs.myPrint.print();
    },
    createQRCode() {
      const vm = this;
      // if (vm.signTime.length < 2) {
      //     vm.$message({
      //         message: '请选中签到签退时间',
      //         type: 'warning'
      //     });
      //     return
      // }
      // vm.qrCodeForm.signStartTime = vm.signTime[0] / 1000
      // vm.qrCodeForm.signEndTime = vm.signTime[1] / 1000
      const param = Object.assign({}, vm.qrCodeForm);
      api.GenerateSignQrCode(param).then((res) => {
        if (res.data.Code === 0) {
          vm.qrCodeUrl = res.data.Data;
          vm.isCreateQRCode = false;
        }
      });
    },
    showQRCode(row) {
      const vm = this;
      vm.tips = row;
      vm.qrCodeForm.id = row.Id;
      vm.qrCodeForm.signUrl =
        "https://www.zjredcross.org/pages/volunteerSign/volunteerSign";
      let qrcode = document.getElementById("qrcode");
      if (qrcode !== null) {
        qrcode.innerHTML = "";
      }
      // vm.isCreateQRCode = true
      // vm.signTime = []
      const param = Object.assign({}, vm.qrCodeForm);
      api.GenerateSignQrCode(param).then((res) => {
        if (res.data.Code === 0) {
          vm.qrCodeUrl = res.data.Data;
          vm.qrCodeDialog = true;
          // vm.isCreateQRCode = false
        }
      });
    },
    onExceed() {
      const vm = this;
      vm.$message({ message: "封面图只能上传一张", type: "error" });
    },
    onSuccess(response) {
      const vm = this;
      if (response.Code === 0) {
        const obj = {
          url: "/files" + response.Data.StorePath,
          name: response.Data.FullName,
        };
        vm.form.Cover = JSON.stringify(obj);
      }
    },
    rollback(row) {
      const vm = this;
      const text = "确定撤销选中志愿者活动？";
      vm.ChangeVolunteerRecruitState(row.Id, 4, text);
    },
    updateState(row) {
      const vm = this;
      const text = "确定发布选中志愿者活动？";
      vm.ChangeVolunteerRecruitState(row.Id, 2, text);
    },
    ChangeVolunteerRecruitState(id, state, text) {
      const vm = this;
      vm.$confirm(text, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        const param = {
          id: id,
          state: state,
        };
        api.ChangeVolunteerRecruitState(param).then((res) => {
          if (res.data.Code === 0) {
            vm.$message({
              message: "已提交",
              type: "success",
            });
            vm.loadData(1);
          } else {
            vm.$message({
              message: res.data.Message,
              type: "error",
            });
          }
        });
      });
    },
    deleted(row) {
      const vm = this;
      vm.$confirm("确认删除选择志愿者活动?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        const param = { id: row.Id };
        api.DeletedVolunteerRecruitById(param).then((res) => {
          if (res.data.Code === 0) {
            vm.$message({
              message: "保存成功",
              type: "success",
            });
            vm.loadData(1);
          } else {
            vm.$message({
              message: res.data.Message,
              type: "error",
            });
          }
        });
      });
    },
    edit(row) {
      const vm = this;
      vm.form = Object.assign({}, row);
      // vm.form.ApplyStartTime = vm.form.ApplyStartTime * 1000
      vm.form.ApplyEndTime = vm.form.ApplyEndTime * 1000;
      vm.form.ActivityStartTime = vm.form.ActivityStartTime * 1000;
      vm.form.ActivityEndTime = vm.form.ActivityEndTime * 1000;
      const address = vm.form.CityCode.split(",");
      vm.addre.province = address[0];
      vm.addre.city = address[1];
      vm.addre.area = address[2];
      vm.addre.town = address[3];
      vm.fileList = [];
      vm.fileList.push(JSON.parse(vm.form.Cover));
      vm.title = "编辑志愿者活动";
      vm.getActivityType();
      vm.dialogVisible = true;
    },
    showState(row) {
      const vm = this;
      if (row.State === 2) {
        const now = Date.parse(new Date()) / 1000;
        if (now < row.ActivityStartTime) {
          return "活动招募中";
        } else if (now > row.ActivityStartTime && now < row.ActivityEndTime) {
          return "活动执行";
        } else if (now > row.ActivityEndTime) {
          return "执行完成";
        }
      } else {
        return formatData(row.State, vm.volunteerRecruitState);
      }
    },
    onSubmit() {
      const vm = this;
      vm.$refs.form.validate((valid) => {
        if (valid) {
          let param = Object.assign({}, vm.form);
          if (!param.CityCode || !param.CityName) {
            vm.$message({
              message: "请选择服务地址",
              type: "warning",
            });
            return;
          }
          param.ApplyStartTime = 0;
          param.ApplyEndTime = param.ApplyEndTime / 1000;
          param.ActivityStartTime = param.ActivityStartTime / 1000;
          param.ActivityEndTime = param.ActivityEndTime / 1000;
          api.SaveVolunteerRecruit(param).then((res) => {
            if (res.data.Code === 0) {
              vm.$message({
                message: "保存成功",
                type: "success",
              });
              vm.loadData(1);
              vm.dialogVisible = false;
            }
          });
        }
      });
    },
    regionChange(data) {
      let vm = this;
      if (data.province !== null) {
        vm.form.CityCode = data.province.key;
        vm.form.CityName = data.province.value;
      }
      if (data.city !== null) {
        vm.form.CityCode = vm.form.CityCode + "," + data.city.key;
        vm.form.CityName += data.city.value;
      }
      if (data.area !== null) {
        vm.form.CityCode = vm.form.CityCode + "," + data.area.key;
        vm.form.CityName += data.area.value;
      }
      if (data.town !== null) {
        vm.form.CityCode = vm.form.CityCode + "," + data.town.key;
        vm.form.CityName += data.town.value;
      }
    },
    getActivityType() {
      const vm = this;
      const param = {
        pageIndex: 1,
        pageSize: 10000,
        ItemKey: "RC_VolunteerType",
      };
      api.GetActivityTypeList(param).then((res) => {
        if (res.data.Code === 0) {
          vm.activityTypeList = res.data.Data.rows;
        }
      });
    },
    add() {
      const vm = this;
      vm.title = "新增志愿者活动";
      vm.form = {};
      vm.getActivityType();
      vm.dialogVisible = true;
    },
    loadData(pageIndex) {
      const vm = this;
      vm.request.pageIndex = pageIndex;
      api.QueryVolunteerRecruit(vm.request).then((res) => {
        if (res.data.Code === 0) {
          vm.list = res.data.Data.rows;
          vm.total = res.data.Data.total;
          vm.loading = false;
        }
      });
    },
    handleCurrentChange(pageIndex) {
      const vm = this;
      if (vm.total > vm.request.pageSize) {
        vm.loadData(pageIndex);
      }
    },
    handleSizeChange(pageSize) {
      const vm = this;
      vm.request.pageSize = pageSize;
      vm.loadData(1);
    },
    //表格高度
    tableMaxHeight() {
      var clientHeight = window.innerHeight;
      var tableMaxHeight = 0;
      if (clientHeight && clientHeight !== undefined) {
        tableMaxHeight = clientHeight - 363;
      }
      return tableMaxHeight;
    },
  },
};
</script>
<style lang="scss" scoped>
.volunteerRecruitList {
  .editContent {
    max-height: 65vh;
    overflow-y: auto;

    .datePicker {
      padding: 0 !important;
    }
  }

  .qrCodeDialog {
    /deep/ .el-dialog__body {
      max-height: 73vh;
      overflow-y: auto;
    }

    .datePicker {
      padding: 0 !important;
    }

    .qrcode {
      display: inline-block;
      padding: 6px;
      background-color: #fff;
      margin-left: 27%;
    }

    .title {
      width: 100%;
      text-align: center;
      margin-bottom: 10px;
    }

    .box {
      margin-bottom: 5px;

      .box-left {
        text-align: right;
      }

      .box-right {
      }
    }

    .tips {
      padding-left: 10%;
      color: red;

      div {
        margin: 5px;
      }
    }
  }

  .search-box {
    text-align: right;

    .toolBar-search {
      width: 300px;
      margin-right: 10px;
    }
  }

  .upload-demo {
    /deep/ .el-upload__input {
      display: none !important;
    }

    /deep/ .el-upload-dragger {
      width: 250px;
      height: 125px;
    }

    /deep/ .el-icon-upload {
      margin: 20px 0 16px;
    }
  }

  /deep/ .el-input--prefix .el-input__inner {
    text-align: center;
  }
  .query-content {
    // max-height: 70vh;
    // overflow-y: auto;
    .query-row {
      border-bottom: 1px dashed rgb(201, 198, 198);
      padding: 5px;
      display: flex;
      .query-label {
        flex: 0.2;
        text-align: right;
      }
      .query-value {
        flex: 0.8;
        .btnCover {
          padding: 0;
        }
      }
    }
  }
}
</style>
